import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../../common/service.base';
import { List } from '../../../common/model/List_T';
import { AppConfig } from '../../../configuration/app.config';
import { AuthService } from '../../../services/auth.service';
import { View } from '../../../common/model/view';

import { FormDescriptor } from '../../form/model/form';

export class FormDescriptorWithIcon extends FormDescriptor {
  icon: string;
}

class GetFormsForManualDataEntryCreationResponse {
  forms: FormDescriptorWithIcon[]
}

class GetFormsForManualDataEntryDeletionResponse {
  forms: string[]
}

class CreateDataEntryResponse {
  dataEntryId: string;
}

class DeleteDataEntryResponse {

}

@Injectable()
export class ManualCreateService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'manualcreatedataentry',
      authService,
      config.BFFSConfig
    );
  }

  public async GetForms(organizationId: string): Promise<FormDescriptorWithIcon[]> {
    return (await super.post<GetFormsForManualDataEntryCreationResponse>({ organizationId }, null, "getforms")).forms;
  }

  public async CreateDataEntry(organizationId: string, formId: string): Promise<string> {
    return (await super.post<CreateDataEntryResponse>({ organizationId, formId }, null, "create")).dataEntryId;
  }
  
  public async GetDeletableForms(): Promise<string[]> {
    return (await super.post<GetFormsForManualDataEntryDeletionResponse>({}, null, "getformsdeletable")).forms;
  }

  public async DeleteDataEntry(dataEntryId: string): Promise<any> {
    return (await super.post<DeleteDataEntryResponse>({ dataEntryId }, null, "delete"));
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dataentry/manualcreate/manualcreate.service.ts